import { createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/attachment-black.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "max-w-none w-6",
  alt: "total-dex"
}, null, -1)
const _hoisted_2 = { class: "pl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: 
      `border border-gray-lp-400 rounded-md p-3 ${_ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'} flex flex-row align-middle font-normal ${
        _ctx.isImageChange ? 'text-red-lp-100' : 'text-gray-lp-500'
      } text-center`
    ,
      style: {"height":"30%"},
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.banner.click()))
    }, [
      _hoisted_1,
      _createVNode("div", _hoisted_2, _toDisplayString(!_ctx.isImageChange ? _ctx.title : _ctx.fileName), 1)
    ], 2),
    _createVNode("input", {
      type: "file",
      ref: "banner",
      onChange: _cache[2] || (_cache[2] = e => _ctx.onUploadImage(e)),
      accept: `.jpg,.png`,
      class: "hidden",
      disabled: _ctx.disabled
    }, null, 40, ["accept", "disabled"])
  ], 64))
}